import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import TransactionTable from './components/TransactionTable'

// Breadcrumbs
const crmBreadcrumb: PageLink = { title: 'CRM', path: '/', isSeparator: false, isActive: false }

function TransactionPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Transaction</PageTitle>
              <TransactionTable />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default TransactionPage
